
$(document).ready(function () {
  if($('.footer').length > 0) {
    // Collapse
    const collapseFooter = document.querySelectorAll('.footer .collapse')
    collapseFooter.forEach(element => {
      element.addEventListener('click', (e) => {
        const el = e.target
        if (el) {
          if (el.classList.contains('is-show')) el.classList.remove('is-show')
          else el.classList.add('is-show')
        }
      })
    })
  }
});